// MessageTable.tsx
import React, { useEffect, useState } from 'react';
import * as XLSX from 'xlsx';
import { httpss } from '../utils/host';
import ExportMessenger from '../components/ExportExcel/ExportMessenger';

export default function MessageTable() {
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(50);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('')
  const [sortField, setSortField] = useState('createdAt');
  const [sortOrder, setSortOrder] = useState('desc');

  const fetchData = async () => {
    const query = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      search,
      sortField,
      sortOrder,
    });

    const res = await fetch(`${httpss}/apis_v1/user/mess?${query}`);
    const json = await res.json();

    setData(json.data || []);
    setTotal(json.total);
  };

  useEffect(() => {
    fetchData();
  }, [page, limit, debouncedSearchTerm, sortField, sortOrder]);

  const totalPages = Math.ceil(total / limit);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchTerm(search);
    }, 300); 

    return () => clearTimeout(timer);
  }, [search]);

  return (
    <div className="p-4">
      <div className="flex justify-between items-center mb-4">
        <input
          type="search"
          placeholder="Tìm kiếm email..."
          value={search}
          onChange={(e) => {
            setPage(1);
            setSearch(e.target.value);
          }}
          className="border p-2 rounded-lg w-1/3 outline-none"
        />

        <div className='flex items-center gap-2'>
          <p>Tổng {total}</p>
          <ExportMessenger />
        </div>
      </div>

      <div className="overflow-x-auto rounded-lg h-[80vh] custom-scrollbar">
        <table className="w-full border text-sm text-left rounded-lg">
          <thead className='sticky top-0 bg-gray-200 z-0'>
            <tr className="bg-gray-100">
              {['id', 'email', 'text', 'name', 'User365Name', 'FanPageFBName', 'createdAt'].map((col) => (
                <th
                  key={col}
                  onClick={() => {
                    setSortField(col);
                    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc');
                  }}
                  className="p-2 border cursor-pointer hover:bg-gray-200"
                >
                  {col} {sortField === col ? (sortOrder === 'asc' ? '↑' : '↓') : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.length === 0 ? (
              <tr>
                <td colSpan={7} className="text-center p-4">
                  Không có dữ liệu.
                </td>
              </tr>
            ) : (
              Array.isArray(data) && data.map((item,index) => (
                <tr key={item.id} className="hover:bg-gray-50">
                  <td className="border p-2">{item.id}</td>
                  <td className="border p-2">{item.email}</td>
                  <td className="border p-2">{item.text}</td>
                  <td className="border p-2">{item.userFB?.name || ''}</td>
                  <td className="border p-2">{item.userFB?.User365Name || ''}</td>
                  <td className="border p-2">{item.FanPageFBName || ''}</td>
                  <td className="border p-2">{new Date(item.createdAt).toLocaleString()}</td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex justify-between items-center mt-2 text-xs">
        <div className="flex items-center gap-2">
          <button
            disabled={page <= 1}
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            className="px-2 py-1 border rounded disabled:opacity-50"
          >
            &lt;
          </button>
          <div>
            Trang {page} / {totalPages}
          </div>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            className="px-2 py-1 border rounded disabled:opacity-50"
          >
            &gt;
          </button>
        </div>
        <div className="flex items-center gap-2">
          <label>Số dòng / trang:</label>
          <select
            className="border rounded p-1"
            value={limit}
            onChange={(e) => {
              setPage(1);
              setLimit(Number(e.target.value));
            }}
          >
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value={200}>200</option>
            <option value={1000}>1000</option>
          </select>

        </div>
      </div>
    </div>
  );
}
